import { ZodError, z } from 'zod';
import { RequestSchema } from '@/data/request/model';
import Monolith from '@/shared/api/monolith';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk } from '@/store';

type CreateRequestArgs = {
  start_time: string;
  end_time: string;
  type_id: number;
  paid: boolean;
  user_id: number;
  message: string;
  hours: number;
};

export const createRequest = createWiwAsyncThunk<z.infer<typeof CreateRequestResponse>, CreateRequestArgs>(
  'request/create',
  async (request, { rejectWithValue }) => {
    try {
      const response = await Monolith.url('/requests').post(request);
      return CreateRequestResponse.parse(response);
    } catch (error) {
      if (error instanceof ZodError) {
        return rejectWithValue(error);
      }

      return rejectWithValue(parseAPIError(error));
    }
  },
);

const CreateRequestResponse = z.object({
  request: RequestSchema,
});
